<template>
    <table class="table table-sm border">
        <template v-for="(t,i) in ($safe(row,'Garages') || [])">
            <tr>
                <td rowspan="2" class="p-25 border-right">
                    <div class="d-flex flex-column g-25">
                        <button v-on:click="$emit('action','garage-edit',row,t)" class="btn btn-sm btn-icon btn-flat-danger">
                            <feather-icon icon="Edit2Icon"></feather-icon>
                        </button>
                        <button v-on:click="$emit('action','garage-delete',row,t)" class="btn btn-sm btn-icon btn-flat-secondary">
                            <feather-icon icon="TrashIcon"></feather-icon>
                        </button>
                    </div>
                </td>
                <td :class="['text-nowrap',i == 0 ? 'border-0' : 'border-top-3','w-34',{'bg-light-secondary':!$safe(t,'GarageEndDateStr') && $safe(t,'Active')}]">
                    <small>Görev Yeri</small>
                    <div class="font-weight-bolder">{{ $safe(t,'VehicleInventoryGarage.GarageName') || '-' }}</div>
                </td>
                <td :class="['text-nowrap',i == 0 ? 'border-0' : 'border-top-3','w-33']">
                    <small>Başlangıç Tarihi</small>
                    <div class="font-weight-bolder">{{ $safe(t,'GarageStartDateStr') || '-' }}</div>
                </td>
                <td :class="['text-nowrap',i == 0 ? 'border-0' : 'border-top-3','w-33']">
                    <small>Bitiş Tarihi</small>
                    <div class="font-weight-bolder">{{ $safe(t,'GarageEndDateStr') || '-' }}</div>
                </td>
            </tr>
            <tr>
                <td colspan="3">
                    <small :class="$safe(t,'GarageEndDateStr') ? 'text-muted' : 'text-secondary'">{{ text($safe(t,'VehicleInventoryGarage.GarageName'),$safe(t,'GarageStartDateStr'),$safe(t,'GarageEndDateStr')) }}</small>
                </td>
            </tr>
        </template>
        <tr v-if="($safe(row,'Garages') || []).length == 0">
            <td colspan="3" class="text-center">
                Bu personelin bir görev yeri bulunmamaktadır.
            </td>
        </tr>
    </table>
</template>

<script>
export default {
    props:{
        row:Object,
        field:Object
    },
    methods:{
        text(t,s,e){
            if(s){
                if(e){
                    return `[${t || '-'}] görev yerine (${s}) tarihinde atanmış, (${e}) tarinde ataması kaldırılmıştır.`
                }else return `[${t || '-'}] görev yerine (${s}) tarihinde atanmış ve hala bu görev yerinde çalışmaktadır.`
            }else return null
        }
    }
}
</script>

<style>
.border-top-2{
    border-top: 2px ;
}
</style>